import processClient from '.'
import { getAuthHeaders } from 'utils/requests'

// Movimentações salvas pelo robô (não consulta o tribunal)
const getMovimentacoesProcesso = async (processId) => {
  const { data } = await processClient.get(`/${processId}/movimentacoes`, { headers: getAuthHeaders() })
  return data
}

export default getMovimentacoesProcesso
